import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const notEmptyHtmlValidationRuleResolver: BaseValidationRuleResolver<string | null | undefined> = (value) => {
  // Rich text is canonical at this boundary: editor and backend both represent empty content as "".
  return value == null || value.length === 0 ? 'Required' : null;
};
